export const CONTENT = {
  pl: {
    htmlLang: "pl",
    title:
      "Rezydencja REAL — Miejsce dobrych spotkań i owocnej współpracy",
    brand: {
      name: "Rezydencja REAL",
      tagline: "Miejsce dobrych spotkań i owocnej współpracy",
      intro: [
        "Rezydencja REAL to niekomercyjna, prywatna przestrzeń pozostająca do wyłącznej dyspozycji wszystkich podmiotów Grupy REAL.",
        "Stworzyliśmy ją z myślą o naszych pracownikach, przyjaciołach, partnerach biznesowych i osobach związanych z Grupą REAL. To miejsce wewnętrznych spotkań, rozmów, wymiany doświadczeń i wspólnej pracy — przestrzeń, w której pomysły nabierają kształtu, a współpraca zaczyna się od dobrego spotkania.",
        "Organizujemy tu konferencje, panele dyskusyjne, spotkania zespołowe, warsztaty i integracje. Rezydencja sprzyja kreatywnej pracy, budowaniu relacji, inspiracji i wspólnemu świętowaniu sukcesów — wszystko w komfortowej, kameralnej atmosferze.",
      ],
      address: { street: "ul. Siedlecka 82", city: "08-114 Skórzec" },
    },
    nav: {
      links: [
        { label: "O Rezydencji", href: "#o-rezydencji" },
        { label: "Sale konferencyjne", href: "#sale-konferencyjne" },
        { label: "Pokoje", href: "#komfortowe-pokoje" },
        { label: "Strefa SPA", href: "#strefa-spa" },
        { label: "Gry i rozrywka", href: "#strefa-gier" },
        { label: "Ogród", href: "#ogrod-i-pawilon" },
        { label: "Jedzenie", href: "#pyszne-jedzenie" },
        { label: "Gdzie nas znaleźć", href: "#gdzie-nas-znalezc" },
      ],
      openMenu: "Otwórz menu",
      closeMenu: "Zamknij menu",
    },
    hero: {
      eyebrow: "Konferencje · Szkolenia · Integracje",
      subtitle: "Miejsce dobrych spotkań i owocnej współpracy",
      ctaPrimary: "Poznaj przestrzenie",
      ctaSecondary: "O Rezydencji",
      scroll: "Przewiń",
      heroAlt: "Salon Rezydencji REAL z widokiem na ogród",
    },
    marquee: [
      "Konferencje",
      "Panele dyskusyjne",
      "Spotkania firmowe",
      "Integracje",
      "Szkolenia",
      "Świętowanie sukcesów",
    ],
    intro: {
      eyebrow: "O Rezydencji",
      heading: ["Poznaj wspólne przestrzenie ", "Rezydencji REAL"],
      quickNavLabel: null,
    },
    map: {
      title: ["Gdzie nas ", "znaleźć"],
      addressLabel: "Adres",
      directions: "Wyznacz trasę",
      directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=Siedlecka%2082%2C%2008-114%20Sk%C3%B3rzec",
      mapTitle:
        "Mapa dojazdu — Rezydencja REAL, ul. Siedlecka 82, 08-114 Skórzec",
    },
    footer: {
      description:
        "Konferencje, panele dyskusyjne i spotkania firmowe, a także integracje i szkolenia.",
      note: "Strona informacyjna",
    },
    spaces: [
      {
        id: "sale-konferencyjne",
        num: "01",
        title: "Sale konferencyjne",
        lead: "Przestrzeń do spotkań, które inspirują i prowadzą do nowych pomysłów.",
        features: [
          "Duża sala konferencyjna — dla grup do 40 osób; idealna na konferencje, prezentacje i panele dyskusyjne.",
          "Kameralna sala — prywatne miejsce na rozmowy i spotkania w mniejszym gronie.",
        ],
        images: [
          {
            src: "/images/sala.jpg",
            alt: "Duża sala konferencyjna z długim stołem, ekranem i widokiem na ogród",
          },
        ],
      },
      {
        id: "komfortowe-pokoje",
        num: "02",
        title: "Komfortowe pokoje",
        lead: "Po intensywnym dniu spotkań dobrze mieć przestrzeń, w której można zwolnić i naprawdę odpocząć. Nasze pokoje są przytulne, komfortowe i wyposażone tak, aby zapewnić wygodny pobyt.",
        features: [
          "Prywatna łazienka w każdym pokoju",
          "Telewizor do wieczornego relaksu",
          "Suszarka do włosów",
          "Zestaw kosmetyków dostępny w łazience",
          "Komfortowa i spokojna przestrzeń sprzyjająca odpoczynkowi po całym dniu",
        ],
        images: [
          {
            src: "/images/pokoj.jpg",
            alt: "Przytulny pokój dwuosobowy z dużym łóżkiem i ozdobną tapetą",
          },
          {
            src: "/images/lazienka.jpg",
            alt: "Prywatna łazienka z wanną, złotymi armaturą i ręcznikami",
          },
        ],
      },
      {
        id: "strefa-spa",
        num: "03",
        title: "Strefa SPA",
        lead: "Chwila oddechu po intensywnym dniu — w swoim tempie i tak, jak lubisz.",
        features: [
          "Basen, sauna i jacuzzi pozwalają się odprężyć i nabrać energii.",
          "Leżaki zapraszają do spokojnego wypoczynku, a fotel do masażu pomaga rozluźnić się po całym dniu.",
        ],
        note: "Pamiętaj o stroju kąpielowym",
        images: [
          {
            src: "/images/basen.jpg",
            alt: "Basen wewnętrzny z leżakami i jacuzzi przy przeszkleniach na ogród",
          },
          {
            src: "/images/masaz.jpg",
            alt: "Gabinet masażu z fotelami i drewnianymi meblami",
          },
          {
            src: "/images/spa-loungers.jpg",
            alt: "Leżaki i jacuzzi w strefie SPA z widokiem na ogród",
          },
        ],
      },
      {
        id: "strefa-gier",
        num: "04",
        title: "Strefa gier i rozrywki",
        lead: "Miejsce na wspólną zabawę i swobodny relaks po spotkaniach.",
        features: [
          "Bilard i pokój gier z PlayStation zachęcają do przyjaznej rywalizacji.",
          "Bar z dużym telewizorem tworzy wygodną przestrzeń, by spędzić czas razem.",
        ],
        images: [
          {
            src: "/images/bilard.jpg",
            alt: "Stół do bilardu w pokoju gier z ciemnym stropem",
          },
          {
            src: "/images/bar.jpg",
            alt: "Bar z dużym telewizorem i wygodną sofą",
          },
        ],
      },
      {
        id: "ogrod-i-pawilon",
        num: "05",
        title: "Ogród i pawilon na wodzie",
        lead: "Nieformalne spotkania najlepiej smakują na świeżym powietrzu.",
        features: [
          "Strefa grillowa sprzyja integracji i wspólnym chwilom przy stole.",
          "Pawilon na wodzie to wyjątkowe miejsce na rozmowę, odpoczynek lub kameralne spotkanie.",
        ],
        images: [
          {
            src: "/images/ogrod.jpg",
            alt: "Zielony ogród z pawilonem szklarnią i ławkami",
          },
          {
            src: "/images/pawilon.jpg",
            alt: "Nowoczesny pawilon na wodzie z tarasem nad stawem",
          },
        ],
      },
      {
        id: "pyszne-jedzenie",
        num: "06",
        title: "Pyszne jedzenie",
        lead: "Dobre jedzenie dopełnia wspólny czas i sprawia, że spotkania stają się jeszcze przyjemniejsze.",
        features: [
          "Serwujemy pyszne dania, którymi można cieszyć się podczas spotkań i przerw.",
          "To smakowity dodatek do dnia pełnego rozmów, pomysłów i dobrej atmosfery.",
        ],
        images: [
          {
            src: "/images/kuchnia.jpg",
            alt: "Przestronna kuchnia Rezydencji ze złotymi lampami i wyspą",
          },
          {
            src: "https://images.pexels.com/photos/27833033/pexels-photo-27833033.jpeg?auto=compress&cs=tinysrgb&w=1400",
            alt: "Tatar wołowy z żółtkiem elegancko podany na talerzu",
          },
        ],
      },
    ],
  },
  en: {
    htmlLang: "en",
    title:
      "Rezydencja REAL — A place for great meetings and fruitful collaborations",
    brand: {
      name: "Rezydencja REAL",
      tagline: "A place for great meetings and fruitful collaborations",
      intro: [
        "Rezydencja REAL is a non-commercial, private space available exclusively to REAL S.A. and its capital-affiliated companies.",
        "We created it with our employees, friends, business partners and everyone connected with the REAL Group in mind. It is a place for internal meetings, conversations, the exchange of experience and working together — a space where ideas take shape and collaboration begins with a good meeting.",
        "We host conferences, panel discussions, team meetings, workshops and team-building events. The Residence fosters creative work, relationship building, inspiration and the shared celebration of success — all in a comfortable, intimate atmosphere.",
      ],
      address: { street: "ul. Siedlecka 82", city: "08-114 Skórzec" },
    },
    nav: {
      links: [
        { label: "About the Residence", href: "#o-rezydencji" },
        { label: "Conference rooms", href: "#sale-konferencyjne" },
        { label: "Rooms", href: "#komfortowe-pokoje" },
        { label: "SPA zone", href: "#strefa-spa" },
        { label: "Games", href: "#strefa-gier" },
        { label: "Garden", href: "#ogrod-i-pawilon" },
        { label: "Dining", href: "#pyszne-jedzenie" },
        { label: "Where to find us", href: "#gdzie-nas-znalezc" },
      ],
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      eyebrow: "Conferences · Trainings · Team building",
      subtitle: "A place for great meetings and fruitful collaborations",
      ctaPrimary: "Explore the spaces",
      ctaSecondary: "About the Residence",
      scroll: "Scroll",
      heroAlt: "The lounge of Rezydencja REAL overlooking the garden",
    },
    marquee: [
      "Conferences",
      "Panel discussions",
      "Corporate meetings",
      "Team building",
      "Trainings",
      "Celebrating success",
    ],
    intro: {
      eyebrow: "About the Residence",
      heading: ["Discover the shared spaces of ", "Rezydencja REAL"],
      quickNavLabel: null,
    },
    map: {
      title: ["Where to ", "find us"],
      addressLabel: "Address",
      directions: "Get directions",
      directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=Siedlecka%2082%2C%2008-114%20Sk%C3%B3rzec",
      mapTitle: "Directions map — Rezydencja REAL, ul. Siedlecka 82, 08-114 Skórzec",
    },
    footer: {
      description:
        "Conferences, panel discussions and corporate meetings, as well as team building and trainings.",
      note: "Informational website",
    },
    spaces: [
      {
        id: "sale-konferencyjne",
        num: "01",
        title: "Conference rooms",
        lead: "A space for meetings that inspire and lead to new ideas.",
        features: [
          "Large conference room — for groups of up to 40 people; perfect for conferences, presentations and panel discussions.",
          "Intimate room — a private space for conversations and meetings in a smaller group.",
        ],
        images: [
          {
            src: "/images/sala.jpg",
            alt: "Large conference room with a long table, a screen and a garden view",
          },
        ],
      },
      {
        id: "komfortowe-pokoje",
        num: "02",
        title: "Comfortable rooms",
        lead: "After an intense day of meetings, it is good to have a space where you can slow down and truly rest. Our rooms are cozy, comfortable and equipped to ensure a pleasant stay.",
        features: [
          "Private bathroom in every room",
          "TV for evening relaxation",
          "Hair dryer",
          "Toiletries available in the bathroom",
          "Comfortable, quiet space perfect for resting after a whole day",
        ],
        images: [
          {
            src: "/images/pokoj.jpg",
            alt: "Cozy double room with a large bed and decorative wallpaper",
          },
          {
            src: "/images/lazienka.jpg",
            alt: "Private bathroom with a bathtub, gold fittings and towels",
          },
        ],
      },
      {
        id: "strefa-spa",
        num: "03",
        title: "SPA zone",
        lead: "A moment to breathe after an intense day — at your own pace, just the way you like it.",
        features: [
          "The pool, sauna and jacuzzi help you unwind and recharge.",
          "Sun loungers invite you to relax quietly, and the massage chair helps you loosen up after a whole day.",
        ],
        note: "Remember to bring your swimwear",
        images: [
          {
            src: "/images/basen.jpg",
            alt: "Indoor pool with sun loungers and a jacuzzi by the garden-facing windows",
          },
          {
            src: "/images/masaz.jpg",
            alt: "Massage room with chairs and wooden furniture",
          },
          {
            src: "/images/spa-loungers.jpg",
            alt: "Sun loungers and a jacuzzi in the SPA zone overlooking the garden",
          },
        ],
      },
      {
        id: "strefa-gier",
        num: "04",
        title: "Games and entertainment zone",
        lead: "A place for shared fun and easy-going relaxation after meetings.",
        features: [
          "The billiards table and PlayStation game room encourage friendly competition.",
          "A bar with a large TV creates a comfortable space to spend time together.",
        ],
        images: [
          {
            src: "/images/bilard.jpg",
            alt: "Billiards table in the game room under a dark ceiling",
          },
          {
            src: "/images/bar.jpg",
            alt: "Bar with a large TV and a comfortable sofa",
          },
        ],
      },
      {
        id: "ogrod-i-pawilon",
        num: "05",
        title: "Garden and pavilion on the water",
        lead: "Informal meetings taste best in the fresh air.",
        features: [
          "The barbecue area is perfect for team building and shared moments at the table.",
          "The pavilion on the water is a unique place for a conversation, a moment of rest or an intimate meeting.",
        ],
        images: [
          {
            src: "/images/ogrod.jpg",
            alt: "Green garden with a glasshouse pavilion and benches",
          },
          {
            src: "/images/pawilon.jpg",
            alt: "Modern pavilion on the water with a terrace above the pond",
          },
        ],
      },
      {
        id: "pyszne-jedzenie",
        num: "06",
        title: "Delicious food",
        lead: "Good food completes the time spent together and makes meetings even more enjoyable.",
        features: [
          "We serve delicious dishes to enjoy during meetings and breaks.",
          "A tasteful addition to a day full of conversations, ideas and a great atmosphere.",
        ],
        images: [
          {
            src: "/images/kuchnia.jpg",
            alt: "Spacious kitchen of the Residence with golden lamps and an island",
          },
          {
            src: "https://images.pexels.com/photos/27833033/pexels-photo-27833033.jpeg?auto=compress&cs=tinysrgb&w=1400",
            alt: "Beef tartare with egg yolk elegantly plated",
          },
        ],
      },
    ],
  },
};
